import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ApiService } from '../services/api.service';
import { catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { Faq } from '../models/faq.model';
import { NavigationService } from '../services/navigation.service';

export const faqDetailResolver: ResolveFn<Faq[]> = (route, state) => {
  const apiService = inject(ApiService);
  const navigationService = inject(NavigationService)

  return apiService.fetchFAQContent().pipe(
    catchError((error) => {
      navigationService.handleResolverError(error);
      return EMPTY;
    })
  );
};
